import { Navigate } from 'react-router-dom';
import useAuthStore from '../../stores/authStore';

/**
 * AdminRoute - Requires admin role
 * Redirects to /login if not authenticated
 * Redirects to / if authenticated but not admin
 */
const AdminRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
